class BsPriceSlider extends HTMLElement {
  connectedCallback() {
    this.max = parseFloat(this.dataset.max) || 0;
    this.sMin = this.querySelector(".bs-price-slider__input--min");
    this.sMax = this.querySelector(".bs-price-slider__input--max");
    this.fill = this.querySelector(".bs-price-slider__fill");
    if (!this.sMin || !this.sMax || !this.max) return;

    var facet = this.closest("price-facet-component");
    this.tMin = facet && facet.querySelector('[ref="minInput"]');
    this.tMax = facet && facet.querySelector('[ref="maxInput"]');

    this.onInput = this.onInput.bind(this);
    this.onCommit = this.onCommit.bind(this);
    this.sMin.addEventListener("input", this.onInput);
    this.sMax.addEventListener("input", this.onInput);
    this.sMin.addEventListener("change", this.onCommit);
    this.sMax.addEventListener("change", this.onCommit);
    if (this.tMin) this.tMin.addEventListener("change", () => this.syncFromText());
    if (this.tMax) this.tMax.addEventListener("change", () => this.syncFromText());

    this.updateFill();
  }

  vals() {
    var lo = parseFloat(this.sMin.value) || 0;
    var hi = parseFloat(this.sMax.value);
    if (isNaN(hi)) hi = this.max;
    if (lo > hi) { var t = lo; lo = hi; hi = t; }
    return [lo, hi];
  }

  onInput(e) {
    var lo = parseFloat(this.sMin.value) || 0;
    var hi = parseFloat(this.sMax.value); if (isNaN(hi)) hi = this.max;
    if (lo > hi) {
      if (e.target === this.sMin) this.sMin.value = hi;
      else this.sMax.value = lo;
    }
    this.updateFill();
    var v = this.vals();
    if (this.tMin) this.tMin.value = v[0] > 0 ? v[0] : "";
    if (this.tMax) this.tMax.value = v[1] < this.max ? v[1] : "";
  }

  onCommit(e) {
    var v = this.vals();
    if (this.tMin) this.tMin.value = v[0] > 0 ? v[0] : "";
    if (this.tMax) this.tMax.value = v[1] < this.max ? v[1] : "";
    var target = (e && e.target === this.sMax) ? this.tMax : this.tMin;
    if (target) target.dispatchEvent(new Event("change", { bubbles: true }));
  }

  syncFromText() {
    if (this.tMin) { var a = parseFloat(this.tMin.value); this.sMin.value = isNaN(a) ? 0 : a; }
    if (this.tMax) { var b = parseFloat(this.tMax.value); this.sMax.value = isNaN(b) ? this.max : b; }
    this.updateFill();
  }

  updateFill() {
    if (!this.fill) return;
    var v = this.vals();
    var left = (v[0] / this.max) * 100;
    var right = (v[1] / this.max) * 100;
    this.fill.style.left = left + "%";
    this.fill.style.width = Math.max(0, right - left) + "%";
  }
}

if (!customElements.get("bs-price-slider")) customElements.define("bs-price-slider", BsPriceSlider);
